var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: {
            placement: "right",
            boundary: "window"
          },
          expression: "{\n\t\tplacement: 'right',\n\t\tboundary: 'window',\n\t}"
        }
      ],
      staticClass: "portal-nav-link",
      class: { "is-active": _vm.active, "is-collapsed": !_vm.expanded },
      attrs: {
        type: "button",
        "aria-current": _vm.active ? "page" : null,
        "aria-label": _vm.label,
        content: _vm.label
      },
      on: { click: _vm.handleClick }
    },
    [
      _c(
        "span",
        { staticClass: "nav-icon-shell", attrs: { "aria-hidden": "true" } },
        [
          _vm.customIcon
            ? _c("custom-page-icon", {
                staticClass: "nav-icon",
                attrs: { name: _vm.icon, size: 21 }
              })
            : _c("portal-icon", {
                staticClass: "nav-icon",
                attrs: { name: _vm.icon, size: 21 }
              })
        ],
        1
      ),
      _vm.expanded
        ? _c("span", { staticClass: "nav-label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm.expanded && _vm.hyperLink
        ? _c("portal-icon", {
            staticClass: "external-icon",
            attrs: { name: "external-link", size: 15 }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }